import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AgeGroup = {
  __typename?: 'AgeGroup';
  from: Scalars['Int'];
  to: Scalars['Int'];
};

export type ByAgeAndGenderLine = {
  __typename?: 'ByAgeAndGenderLine';
  ageGroup: AgeGroup;
  females: ValueOverTime;
  males: ValueOverTime;
  overall: ValueOverTime;
};

export type ByAgeGenderAndReasonLine = {
  __typename?: 'ByAgeGenderAndReasonLine';
  females: ValueOverTime;
  males: ValueOverTime;
  overall: ValueOverTime;
  reason: InactivityReason;
  values: Array<ByAgeAndGenderLine>;
};

export type ByAgeGenderAndRegionLine = {
  __typename?: 'ByAgeGenderAndRegionLine';
  females: ValueOverTime;
  males: ValueOverTime;
  numPopulation: Scalars['Int'];
  overall: ValueOverTime;
  region: Region;
  values: Array<ByAgeAndGenderLine>;
};

export type ByAgeGenderAndRegionResult = {
  __typename?: 'ByAgeGenderAndRegionResult';
  ageGroups: Array<ByAgeAndGenderLine>;
  females: ValueOverTime;
  males: ValueOverTime;
  numPopulation: Scalars['Int'];
  overall: ValueOverTime;
  values: Array<ByAgeGenderAndRegionLine>;
};

export type ByAgeGenderAndSectorLine = {
  __typename?: 'ByAgeGenderAndSectorLine';
  overall: ValueOverTime;
  sector: Sector;
  values: Array<ByAgeGenderAndSubsectorLine>;
};

export type ByAgeGenderAndSubsectorLine = {
  __typename?: 'ByAgeGenderAndSubsectorLine';
  females: ValueOverTime;
  males: ValueOverTime;
  overall: ValueOverTime;
  sector: Sector;
  values: Array<ByAgeAndGenderLine>;
};

export type ByAgeGenderReasonAndRegionLine = {
  __typename?: 'ByAgeGenderReasonAndRegionLine';
  ageGroups: Array<ByAgeAndGenderLine>;
  females: ValueOverTime;
  males: ValueOverTime;
  numPopulation: Scalars['Int'];
  overall: ValueOverTime;
  region: Region;
  values: Array<ByAgeGenderAndReasonLine>;
};

export type ByAgeGenderReasonAndRegionResult = {
  __typename?: 'ByAgeGenderReasonAndRegionResult';
  ageGroups: Array<ByAgeAndGenderLine>;
  females: ValueOverTime;
  males: ValueOverTime;
  numPopulation: Scalars['Int'];
  overall: ValueOverTime;
  values: Array<ByAgeGenderReasonAndRegionLine>;
};

export type ByAgeGenderSectorAndRegionLine = {
  __typename?: 'ByAgeGenderSectorAndRegionLine';
  ageGroups: Array<ByAgeAndGenderLine>;
  females: ValueOverTime;
  males: ValueOverTime;
  numPopulation: Scalars['Int'];
  overall: ValueOverTime;
  region: Region;
  values: Array<ByAgeGenderAndSectorLine>;
};

export type ByAgeGenderSectorAndRegionResult = {
  __typename?: 'ByAgeGenderSectorAndRegionResult';
  ageGroups: Array<ByAgeAndGenderLine>;
  females: ValueOverTime;
  males: ValueOverTime;
  numPopulation: Scalars['Int'];
  overall: ValueOverTime;
  values: Array<ByAgeGenderSectorAndRegionLine>;
};

export type BySectorAndRegionLine = {
  __typename?: 'BySectorAndRegionLine';
  numPopulation: Scalars['Int'];
  overall: ValueOverTime;
  region: Region;
  values: Array<BySectorLine>;
};

export type BySectorAndRegionResult = {
  __typename?: 'BySectorAndRegionResult';
  numPopulation: Scalars['Int'];
  overall: ValueOverTime;
  values: Array<BySectorAndRegionLine>;
};

export type BySectorLine = {
  __typename?: 'BySectorLine';
  overall: ValueOverTime;
  sector: Sector;
  values: Array<BySubsectorLine>;
};

export type BySubsectorLine = {
  __typename?: 'BySubsectorLine';
  overall: ValueOverTime;
  sector: Sector;
};

export enum Direction {
  Falling = 'Falling',
  Rising = 'Rising',
  Steady = 'Steady'
}

export type InactivityReason = {
  __typename?: 'InactivityReason';
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum InsightType {
  Employed = 'Employed',
  Inactive = 'Inactive',
  InactiveAndUnemployed = 'InactiveAndUnemployed',
  OpenJobs = 'OpenJobs',
  Unemployed = 'Unemployed'
}

export type LatLon = {
  __typename?: 'LatLon';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  employedByAgeGenderSectorAndRegion: ByAgeGenderSectorAndRegionResult;
  inactiveAndUnemployedByRegion: ByAgeGenderAndRegionResult;
  inactiveByAgeGenderReasonAndRegion: ByAgeGenderReasonAndRegionResult;
  insights: Array<Scalars['String']>;
  openJobsBySectorAndRegion: BySectorAndRegionResult;
  regions: Array<Region>;
  totalPopulation: Array<TotalPopulationByRegionLine>;
  unemployedByAgeGenderAndRegion: ByAgeGenderAndRegionResult;
};


export type QueryEmployedByAgeGenderSectorAndRegionArgs = {
  year: Scalars['Int'];
};


export type QueryInactiveAndUnemployedByRegionArgs = {
  year: Scalars['Int'];
};


export type QueryInactiveByAgeGenderReasonAndRegionArgs = {
  year: Scalars['Int'];
};


export type QueryInsightsArgs = {
  insightType: InsightType;
  regionName: Scalars['String'];
  year: Scalars['Int'];
};


export type QueryOpenJobsBySectorAndRegionArgs = {
  year: Scalars['Int'];
};


export type QueryRegionsArgs = {
  names?: Array<Scalars['String']>;
};


export type QueryTotalPopulationArgs = {
  year: Scalars['Int'];
};


export type QueryUnemployedByAgeGenderAndRegionArgs = {
  year: Scalars['Int'];
};

export type Region = {
  __typename?: 'Region';
  geoJsonGeometry: Scalars['String'];
  id: Scalars['String'];
  labelLocation?: Maybe<LatLon>;
  name: Scalars['String'];
};

export type Sector = {
  __typename?: 'Sector';
  id: Scalars['String'];
  name: Scalars['String'];
  parent?: Maybe<Sector>;
};

export type TotalPopulationByRegionLine = {
  __typename?: 'TotalPopulationByRegionLine';
  overall: Scalars['Int'];
  region: Region;
};

export type ValueOverTime = {
  __typename?: 'ValueOverTime';
  direction: Direction;
  value: Scalars['Int'];
};

export type AgeGenderGroupFragment = { __typename?: 'ByAgeAndGenderLine', ageGroup: { __typename?: 'AgeGroup', from: number, to: number }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction } };

export type UnemployedAgeAndGenderByYearQueryVariables = Exact<{
  year: Scalars['Int'];
}>;


export type UnemployedAgeAndGenderByYearQuery = { __typename?: 'Query', results: { __typename?: 'ByAgeGenderAndRegionResult', numPopulation: number, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, values: Array<{ __typename?: 'ByAgeAndGenderLine', ageGroup: { __typename?: 'AgeGroup', from: number, to: number }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction } }>, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction } } };

export type EmployedAgeAndGenderByYearQueryVariables = Exact<{
  year: Scalars['Int'];
}>;


export type EmployedAgeAndGenderByYearQuery = { __typename?: 'Query', results: { __typename?: 'ByAgeGenderSectorAndRegionResult', numPopulation: number, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, values: Array<{ __typename?: 'ByAgeAndGenderLine', ageGroup: { __typename?: 'AgeGroup', from: number, to: number }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction } }>, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction } } };

export type InactiveAgeAndGenderByYearQueryVariables = Exact<{
  year: Scalars['Int'];
}>;


export type InactiveAgeAndGenderByYearQuery = { __typename?: 'Query', results: { __typename?: 'ByAgeGenderReasonAndRegionResult', numPopulation: number, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, values: Array<{ __typename?: 'ByAgeAndGenderLine', ageGroup: { __typename?: 'AgeGroup', from: number, to: number }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction } }>, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction } } };

export type CompleteNumberFragment = { __typename?: 'ValueOverTime', value: number, direction: Direction };

export type EmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQueryVariables = Exact<{
  year: Scalars['Int'];
}>;


export type EmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQuery = { __typename?: 'Query', results: { __typename?: 'ByAgeGenderSectorAndRegionResult', overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, values: Array<{ __typename?: 'ByAgeGenderSectorAndRegionLine', numPopulation: number, region: { __typename?: 'Region', id: string, name: string }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, superSectors: Array<{ __typename?: 'ByAgeGenderAndSectorLine', sector: { __typename?: 'Sector', id: string, name: string }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, subSectors: Array<{ __typename?: 'ByAgeGenderAndSubsectorLine', sector: { __typename?: 'Sector', name: string }, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, ageGenderValues: Array<{ __typename?: 'ByAgeAndGenderLine', ageGroup: { __typename?: 'AgeGroup', from: number, to: number }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction } }> }> }>, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction }, values: Array<{ __typename?: 'ByAgeAndGenderLine', ageGroup: { __typename?: 'AgeGroup', from: number, to: number }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction } }> }>, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction }, ageGenderValues: Array<{ __typename?: 'ByAgeAndGenderLine', ageGroup: { __typename?: 'AgeGroup', from: number, to: number }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction } }> } };

export type UnemployedRegionAndAgeAndGenderByYearQueryVariables = Exact<{
  year: Scalars['Int'];
}>;


export type UnemployedRegionAndAgeAndGenderByYearQuery = { __typename?: 'Query', results: { __typename?: 'ByAgeGenderAndRegionResult', overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction }, ageGenderValues: Array<{ __typename?: 'ByAgeAndGenderLine', ageGroup: { __typename?: 'AgeGroup', from: number, to: number }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction } }>, values: Array<{ __typename?: 'ByAgeGenderAndRegionLine', numPopulation: number, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction }, region: { __typename?: 'Region', id: string, name: string }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, values: Array<{ __typename?: 'ByAgeAndGenderLine', ageGroup: { __typename?: 'AgeGroup', from: number, to: number }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction } }> }> } };

export type InactiveReasonsAndRegionAndAgeAndGenderByYearQueryVariables = Exact<{
  year: Scalars['Int'];
}>;


export type InactiveReasonsAndRegionAndAgeAndGenderByYearQuery = { __typename?: 'Query', results: { __typename?: 'ByAgeGenderReasonAndRegionResult', overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, values: Array<{ __typename?: 'ByAgeGenderReasonAndRegionLine', numPopulation: number, region: { __typename?: 'Region', id: string, name: string }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, values: Array<{ __typename?: 'ByAgeAndGenderLine', ageGroup: { __typename?: 'AgeGroup', from: number, to: number }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction } }>, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction }, reasons: Array<{ __typename?: 'ByAgeGenderAndReasonLine', reason: { __typename?: 'InactivityReason', id: string, name: string }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction }, ageGenderValues: Array<{ __typename?: 'ByAgeAndGenderLine', ageGroup: { __typename?: 'AgeGroup', from: number, to: number }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction } }> }> }> } };

export type InactiveAndUnemployedRegionAndAgeAndGenderByYearQueryVariables = Exact<{
  year: Scalars['Int'];
}>;


export type InactiveAndUnemployedRegionAndAgeAndGenderByYearQuery = { __typename?: 'Query', results: { __typename?: 'ByAgeGenderAndRegionResult', overall: { __typename?: 'ValueOverTime', direction: Direction, value: number }, values: Array<{ __typename?: 'ByAgeGenderAndRegionLine', numPopulation: number, region: { __typename?: 'Region', id: string, name: string }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, values: Array<{ __typename?: 'ByAgeAndGenderLine', ageGroup: { __typename?: 'AgeGroup', from: number, to: number }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction } }>, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction }, ageGenderValues: Array<{ __typename?: 'ByAgeAndGenderLine', ageGroup: { __typename?: 'AgeGroup', from: number, to: number }, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction } }> }>, males: { __typename?: 'ValueOverTime', value: number, direction: Direction }, females: { __typename?: 'ValueOverTime', value: number, direction: Direction } } };

export type OpenJobsBySectorAndRegionbyYearQueryVariables = Exact<{
  year: Scalars['Int'];
}>;


export type OpenJobsBySectorAndRegionbyYearQuery = { __typename?: 'Query', results: { __typename?: 'BySectorAndRegionResult', numPopulation: number, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, values: Array<{ __typename?: 'BySectorAndRegionLine', region: { __typename?: 'Region', id: string, name: string }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, superSectors: Array<{ __typename?: 'BySectorLine', overall: { __typename?: 'ValueOverTime', value: number, direction: Direction }, sector: { __typename?: 'Sector', id: string, name: string }, subSectors: Array<{ __typename?: 'BySubsectorLine', sector: { __typename?: 'Sector', name: string }, overall: { __typename?: 'ValueOverTime', value: number, direction: Direction } }> }> }> } };

export type TunisiaRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TunisiaRegionsQuery = { __typename?: 'Query', regions: Array<{ __typename?: 'Region', id: string, name: string }> };

export type RegionsCoordinatesQueryVariables = Exact<{ [key: string]: never; }>;


export type RegionsCoordinatesQuery = { __typename?: 'Query', regions: Array<{ __typename?: 'Region', name: string, id: string, geoJsonGeometry: string }> };

export type NeighbourCountriesWithCoordinatesQueryVariables = Exact<{ [key: string]: never; }>;


export type NeighbourCountriesWithCoordinatesQuery = { __typename?: 'Query', regions: Array<{ __typename?: 'Region', name: string, geoJsonGeometry: string }> };

export type RegionsStatsQueryVariables = Exact<{
  year: Scalars['Int'];
  withNumTotal: Scalars['Boolean'];
  withNumEmployed: Scalars['Boolean'];
  withNumUnemployed: Scalars['Boolean'];
  withNumInactive: Scalars['Boolean'];
  withNumOpenJobs: Scalars['Boolean'];
}>;


export type RegionsStatsQuery = { __typename?: 'Query', totalPopulation: Array<{ __typename?: 'TotalPopulationByRegionLine', overall: number, region: { __typename?: 'Region', id: string, name: string } }>, Employed: { __typename?: 'ByAgeGenderSectorAndRegionResult', values: Array<{ __typename?: 'ByAgeGenderSectorAndRegionLine', region: { __typename?: 'Region', id: string, name: string }, overall: { __typename?: 'ValueOverTime', value: number } }> }, Unemployed: { __typename?: 'ByAgeGenderAndRegionResult', values: Array<{ __typename?: 'ByAgeGenderAndRegionLine', region: { __typename?: 'Region', id: string, name: string }, overall: { __typename?: 'ValueOverTime', value: number } }> }, Inactive: { __typename?: 'ByAgeGenderAndRegionResult', values: Array<{ __typename?: 'ByAgeGenderAndRegionLine', region: { __typename?: 'Region', id: string, name: string }, overall: { __typename?: 'ValueOverTime', value: number } }> }, Job_Openings: { __typename?: 'BySectorAndRegionResult', values: Array<{ __typename?: 'BySectorAndRegionLine', region: { __typename?: 'Region', id: string, name: string }, overall: { __typename?: 'ValueOverTime', value: number } }> } };

export type InsightsQueryVariables = Exact<{
  year: Scalars['Int'];
  regionName: Scalars['String'];
  insightType: InsightType;
}>;


export type InsightsQuery = { __typename?: 'Query', insights: Array<string> };

export const AgeGenderGroupFragmentDoc = gql`
    fragment AgeGenderGroup on ByAgeAndGenderLine {
  ageGroup {
    from
    to
  }
  overall {
    value
    direction
  }
  males {
    value
    direction
  }
  females {
    value
    direction
  }
}
    `;
export const CompleteNumberFragmentDoc = gql`
    fragment CompleteNumber on ValueOverTime {
  value
  direction
}
    `;
export const UnemployedAgeAndGenderByYearDocument = gql`
    query unemployedAgeAndGenderByYear($year: Int!) {
  results: unemployedByAgeGenderAndRegion(year: $year) {
    overall {
      ...CompleteNumber
    }
    numPopulation
    values: ageGroups {
      ...AgeGenderGroup
    }
    males {
      ...CompleteNumber
    }
    females {
      ...CompleteNumber
    }
  }
}
    ${CompleteNumberFragmentDoc}
${AgeGenderGroupFragmentDoc}`;

/**
 * __useUnemployedAgeAndGenderByYearQuery__
 *
 * To run a query within a React component, call `useUnemployedAgeAndGenderByYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnemployedAgeAndGenderByYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnemployedAgeAndGenderByYearQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useUnemployedAgeAndGenderByYearQuery(baseOptions: Apollo.QueryHookOptions<UnemployedAgeAndGenderByYearQuery, UnemployedAgeAndGenderByYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnemployedAgeAndGenderByYearQuery, UnemployedAgeAndGenderByYearQueryVariables>(UnemployedAgeAndGenderByYearDocument, options);
      }
export function useUnemployedAgeAndGenderByYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnemployedAgeAndGenderByYearQuery, UnemployedAgeAndGenderByYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnemployedAgeAndGenderByYearQuery, UnemployedAgeAndGenderByYearQueryVariables>(UnemployedAgeAndGenderByYearDocument, options);
        }
export type UnemployedAgeAndGenderByYearQueryHookResult = ReturnType<typeof useUnemployedAgeAndGenderByYearQuery>;
export type UnemployedAgeAndGenderByYearLazyQueryHookResult = ReturnType<typeof useUnemployedAgeAndGenderByYearLazyQuery>;
export type UnemployedAgeAndGenderByYearQueryResult = Apollo.QueryResult<UnemployedAgeAndGenderByYearQuery, UnemployedAgeAndGenderByYearQueryVariables>;
export const EmployedAgeAndGenderByYearDocument = gql`
    query employedAgeAndGenderByYear($year: Int!) {
  results: employedByAgeGenderSectorAndRegion(year: $year) {
    overall {
      ...CompleteNumber
    }
    numPopulation
    values: ageGroups {
      ...AgeGenderGroup
    }
    males {
      ...CompleteNumber
    }
    females {
      ...CompleteNumber
    }
  }
}
    ${CompleteNumberFragmentDoc}
${AgeGenderGroupFragmentDoc}`;

/**
 * __useEmployedAgeAndGenderByYearQuery__
 *
 * To run a query within a React component, call `useEmployedAgeAndGenderByYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployedAgeAndGenderByYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployedAgeAndGenderByYearQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useEmployedAgeAndGenderByYearQuery(baseOptions: Apollo.QueryHookOptions<EmployedAgeAndGenderByYearQuery, EmployedAgeAndGenderByYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployedAgeAndGenderByYearQuery, EmployedAgeAndGenderByYearQueryVariables>(EmployedAgeAndGenderByYearDocument, options);
      }
export function useEmployedAgeAndGenderByYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployedAgeAndGenderByYearQuery, EmployedAgeAndGenderByYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployedAgeAndGenderByYearQuery, EmployedAgeAndGenderByYearQueryVariables>(EmployedAgeAndGenderByYearDocument, options);
        }
export type EmployedAgeAndGenderByYearQueryHookResult = ReturnType<typeof useEmployedAgeAndGenderByYearQuery>;
export type EmployedAgeAndGenderByYearLazyQueryHookResult = ReturnType<typeof useEmployedAgeAndGenderByYearLazyQuery>;
export type EmployedAgeAndGenderByYearQueryResult = Apollo.QueryResult<EmployedAgeAndGenderByYearQuery, EmployedAgeAndGenderByYearQueryVariables>;
export const InactiveAgeAndGenderByYearDocument = gql`
    query inactiveAgeAndGenderByYear($year: Int!) {
  results: inactiveByAgeGenderReasonAndRegion(year: $year) {
    overall {
      ...CompleteNumber
    }
    numPopulation
    values: ageGroups {
      ...AgeGenderGroup
    }
    males {
      ...CompleteNumber
    }
    females {
      ...CompleteNumber
    }
  }
}
    ${CompleteNumberFragmentDoc}
${AgeGenderGroupFragmentDoc}`;

/**
 * __useInactiveAgeAndGenderByYearQuery__
 *
 * To run a query within a React component, call `useInactiveAgeAndGenderByYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useInactiveAgeAndGenderByYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInactiveAgeAndGenderByYearQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useInactiveAgeAndGenderByYearQuery(baseOptions: Apollo.QueryHookOptions<InactiveAgeAndGenderByYearQuery, InactiveAgeAndGenderByYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InactiveAgeAndGenderByYearQuery, InactiveAgeAndGenderByYearQueryVariables>(InactiveAgeAndGenderByYearDocument, options);
      }
export function useInactiveAgeAndGenderByYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InactiveAgeAndGenderByYearQuery, InactiveAgeAndGenderByYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InactiveAgeAndGenderByYearQuery, InactiveAgeAndGenderByYearQueryVariables>(InactiveAgeAndGenderByYearDocument, options);
        }
export type InactiveAgeAndGenderByYearQueryHookResult = ReturnType<typeof useInactiveAgeAndGenderByYearQuery>;
export type InactiveAgeAndGenderByYearLazyQueryHookResult = ReturnType<typeof useInactiveAgeAndGenderByYearLazyQuery>;
export type InactiveAgeAndGenderByYearQueryResult = Apollo.QueryResult<InactiveAgeAndGenderByYearQuery, InactiveAgeAndGenderByYearQueryVariables>;
export const EmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearDocument = gql`
    query employedRegionAndSectorAndSubsectorAndAgeAndGenderByYear($year: Int!) {
  results: employedByAgeGenderSectorAndRegion(year: $year) {
    overall {
      ...CompleteNumber
    }
    values {
      region {
        id
        name
      }
      numPopulation
      overall {
        ...CompleteNumber
      }
      superSectors: values {
        sector {
          id
          name
        }
        overall {
          ...CompleteNumber
        }
        subSectors: values {
          sector {
            name
          }
          males {
            ...CompleteNumber
          }
          females {
            ...CompleteNumber
          }
          overall {
            ...CompleteNumber
          }
          ageGenderValues: values {
            ...AgeGenderGroup
          }
        }
      }
      males {
        ...CompleteNumber
      }
      females {
        ...CompleteNumber
      }
      values: ageGroups {
        ...AgeGenderGroup
      }
    }
    males {
      ...CompleteNumber
    }
    females {
      ...CompleteNumber
    }
    ageGenderValues: ageGroups {
      ...AgeGenderGroup
    }
  }
}
    ${CompleteNumberFragmentDoc}
${AgeGenderGroupFragmentDoc}`;

/**
 * __useEmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQuery__
 *
 * To run a query within a React component, call `useEmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useEmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQuery(baseOptions: Apollo.QueryHookOptions<EmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQuery, EmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQuery, EmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQueryVariables>(EmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearDocument, options);
      }
export function useEmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQuery, EmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQuery, EmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQueryVariables>(EmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearDocument, options);
        }
export type EmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQueryHookResult = ReturnType<typeof useEmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQuery>;
export type EmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearLazyQueryHookResult = ReturnType<typeof useEmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearLazyQuery>;
export type EmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQueryResult = Apollo.QueryResult<EmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQuery, EmployedRegionAndSectorAndSubsectorAndAgeAndGenderByYearQueryVariables>;
export const UnemployedRegionAndAgeAndGenderByYearDocument = gql`
    query unemployedRegionAndAgeAndGenderByYear($year: Int!) {
  results: unemployedByAgeGenderAndRegion(year: $year) {
    overall {
      ...CompleteNumber
    }
    males {
      ...CompleteNumber
    }
    females {
      ...CompleteNumber
    }
    ageGenderValues: ageGroups {
      ...AgeGenderGroup
    }
    values {
      males {
        ...CompleteNumber
      }
      females {
        ...CompleteNumber
      }
      numPopulation
      region {
        id
        name
      }
      overall {
        ...CompleteNumber
      }
      values: values {
        ageGroup {
          from
          to
        }
        overall {
          ...CompleteNumber
        }
        males {
          ...CompleteNumber
        }
        females {
          ...CompleteNumber
        }
      }
    }
  }
}
    ${CompleteNumberFragmentDoc}
${AgeGenderGroupFragmentDoc}`;

/**
 * __useUnemployedRegionAndAgeAndGenderByYearQuery__
 *
 * To run a query within a React component, call `useUnemployedRegionAndAgeAndGenderByYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnemployedRegionAndAgeAndGenderByYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnemployedRegionAndAgeAndGenderByYearQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useUnemployedRegionAndAgeAndGenderByYearQuery(baseOptions: Apollo.QueryHookOptions<UnemployedRegionAndAgeAndGenderByYearQuery, UnemployedRegionAndAgeAndGenderByYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnemployedRegionAndAgeAndGenderByYearQuery, UnemployedRegionAndAgeAndGenderByYearQueryVariables>(UnemployedRegionAndAgeAndGenderByYearDocument, options);
      }
export function useUnemployedRegionAndAgeAndGenderByYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnemployedRegionAndAgeAndGenderByYearQuery, UnemployedRegionAndAgeAndGenderByYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnemployedRegionAndAgeAndGenderByYearQuery, UnemployedRegionAndAgeAndGenderByYearQueryVariables>(UnemployedRegionAndAgeAndGenderByYearDocument, options);
        }
export type UnemployedRegionAndAgeAndGenderByYearQueryHookResult = ReturnType<typeof useUnemployedRegionAndAgeAndGenderByYearQuery>;
export type UnemployedRegionAndAgeAndGenderByYearLazyQueryHookResult = ReturnType<typeof useUnemployedRegionAndAgeAndGenderByYearLazyQuery>;
export type UnemployedRegionAndAgeAndGenderByYearQueryResult = Apollo.QueryResult<UnemployedRegionAndAgeAndGenderByYearQuery, UnemployedRegionAndAgeAndGenderByYearQueryVariables>;
export const InactiveReasonsAndRegionAndAgeAndGenderByYearDocument = gql`
    query inactiveReasonsAndRegionAndAgeAndGenderByYear($year: Int!) {
  results: inactiveByAgeGenderReasonAndRegion(year: $year) {
    overall {
      value
      direction
    }
    values {
      region {
        id
        name
      }
      numPopulation
      overall {
        value
        direction
      }
      values: ageGroups {
        ...AgeGenderGroup
      }
      males {
        ...CompleteNumber
      }
      females {
        ...CompleteNumber
      }
      reasons: values {
        reason {
          id
          name
        }
        overall {
          value
          direction
        }
        males {
          ...CompleteNumber
        }
        females {
          ...CompleteNumber
        }
        ageGenderValues: values {
          ...AgeGenderGroup
        }
      }
    }
  }
}
    ${AgeGenderGroupFragmentDoc}
${CompleteNumberFragmentDoc}`;

/**
 * __useInactiveReasonsAndRegionAndAgeAndGenderByYearQuery__
 *
 * To run a query within a React component, call `useInactiveReasonsAndRegionAndAgeAndGenderByYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useInactiveReasonsAndRegionAndAgeAndGenderByYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInactiveReasonsAndRegionAndAgeAndGenderByYearQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useInactiveReasonsAndRegionAndAgeAndGenderByYearQuery(baseOptions: Apollo.QueryHookOptions<InactiveReasonsAndRegionAndAgeAndGenderByYearQuery, InactiveReasonsAndRegionAndAgeAndGenderByYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InactiveReasonsAndRegionAndAgeAndGenderByYearQuery, InactiveReasonsAndRegionAndAgeAndGenderByYearQueryVariables>(InactiveReasonsAndRegionAndAgeAndGenderByYearDocument, options);
      }
export function useInactiveReasonsAndRegionAndAgeAndGenderByYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InactiveReasonsAndRegionAndAgeAndGenderByYearQuery, InactiveReasonsAndRegionAndAgeAndGenderByYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InactiveReasonsAndRegionAndAgeAndGenderByYearQuery, InactiveReasonsAndRegionAndAgeAndGenderByYearQueryVariables>(InactiveReasonsAndRegionAndAgeAndGenderByYearDocument, options);
        }
export type InactiveReasonsAndRegionAndAgeAndGenderByYearQueryHookResult = ReturnType<typeof useInactiveReasonsAndRegionAndAgeAndGenderByYearQuery>;
export type InactiveReasonsAndRegionAndAgeAndGenderByYearLazyQueryHookResult = ReturnType<typeof useInactiveReasonsAndRegionAndAgeAndGenderByYearLazyQuery>;
export type InactiveReasonsAndRegionAndAgeAndGenderByYearQueryResult = Apollo.QueryResult<InactiveReasonsAndRegionAndAgeAndGenderByYearQuery, InactiveReasonsAndRegionAndAgeAndGenderByYearQueryVariables>;
export const InactiveAndUnemployedRegionAndAgeAndGenderByYearDocument = gql`
    query inactiveAndUnemployedRegionAndAgeAndGenderByYear($year: Int!) {
  results: inactiveAndUnemployedByRegion(year: $year) {
    overall {
      direction
      value
    }
    values {
      region {
        id
        name
      }
      numPopulation
      overall {
        value
        direction
      }
      values: values {
        ageGroup {
          from
          to
        }
        overall {
          ...CompleteNumber
        }
        males {
          ...CompleteNumber
        }
        females {
          ...CompleteNumber
        }
      }
      males {
        ...CompleteNumber
      }
      females {
        ...CompleteNumber
      }
      ageGenderValues: values {
        ageGroup {
          from
          to
        }
        males {
          value
          direction
        }
        females {
          value
          direction
        }
      }
    }
    males {
      ...CompleteNumber
    }
    females {
      ...CompleteNumber
    }
  }
}
    ${CompleteNumberFragmentDoc}`;

/**
 * __useInactiveAndUnemployedRegionAndAgeAndGenderByYearQuery__
 *
 * To run a query within a React component, call `useInactiveAndUnemployedRegionAndAgeAndGenderByYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useInactiveAndUnemployedRegionAndAgeAndGenderByYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInactiveAndUnemployedRegionAndAgeAndGenderByYearQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useInactiveAndUnemployedRegionAndAgeAndGenderByYearQuery(baseOptions: Apollo.QueryHookOptions<InactiveAndUnemployedRegionAndAgeAndGenderByYearQuery, InactiveAndUnemployedRegionAndAgeAndGenderByYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InactiveAndUnemployedRegionAndAgeAndGenderByYearQuery, InactiveAndUnemployedRegionAndAgeAndGenderByYearQueryVariables>(InactiveAndUnemployedRegionAndAgeAndGenderByYearDocument, options);
      }
export function useInactiveAndUnemployedRegionAndAgeAndGenderByYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InactiveAndUnemployedRegionAndAgeAndGenderByYearQuery, InactiveAndUnemployedRegionAndAgeAndGenderByYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InactiveAndUnemployedRegionAndAgeAndGenderByYearQuery, InactiveAndUnemployedRegionAndAgeAndGenderByYearQueryVariables>(InactiveAndUnemployedRegionAndAgeAndGenderByYearDocument, options);
        }
export type InactiveAndUnemployedRegionAndAgeAndGenderByYearQueryHookResult = ReturnType<typeof useInactiveAndUnemployedRegionAndAgeAndGenderByYearQuery>;
export type InactiveAndUnemployedRegionAndAgeAndGenderByYearLazyQueryHookResult = ReturnType<typeof useInactiveAndUnemployedRegionAndAgeAndGenderByYearLazyQuery>;
export type InactiveAndUnemployedRegionAndAgeAndGenderByYearQueryResult = Apollo.QueryResult<InactiveAndUnemployedRegionAndAgeAndGenderByYearQuery, InactiveAndUnemployedRegionAndAgeAndGenderByYearQueryVariables>;
export const OpenJobsBySectorAndRegionbyYearDocument = gql`
    query openJobsBySectorAndRegionbyYear($year: Int!) {
  results: openJobsBySectorAndRegion(year: $year) {
    overall {
      value
      direction
    }
    numPopulation
    values {
      region {
        id
        name
      }
      overall {
        value
        direction
      }
      superSectors: values {
        overall {
          value
          direction
        }
        sector {
          id
          name
        }
        subSectors: values {
          sector {
            name
          }
          overall {
            value
            direction
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOpenJobsBySectorAndRegionbyYearQuery__
 *
 * To run a query within a React component, call `useOpenJobsBySectorAndRegionbyYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenJobsBySectorAndRegionbyYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenJobsBySectorAndRegionbyYearQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useOpenJobsBySectorAndRegionbyYearQuery(baseOptions: Apollo.QueryHookOptions<OpenJobsBySectorAndRegionbyYearQuery, OpenJobsBySectorAndRegionbyYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenJobsBySectorAndRegionbyYearQuery, OpenJobsBySectorAndRegionbyYearQueryVariables>(OpenJobsBySectorAndRegionbyYearDocument, options);
      }
export function useOpenJobsBySectorAndRegionbyYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenJobsBySectorAndRegionbyYearQuery, OpenJobsBySectorAndRegionbyYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenJobsBySectorAndRegionbyYearQuery, OpenJobsBySectorAndRegionbyYearQueryVariables>(OpenJobsBySectorAndRegionbyYearDocument, options);
        }
export type OpenJobsBySectorAndRegionbyYearQueryHookResult = ReturnType<typeof useOpenJobsBySectorAndRegionbyYearQuery>;
export type OpenJobsBySectorAndRegionbyYearLazyQueryHookResult = ReturnType<typeof useOpenJobsBySectorAndRegionbyYearLazyQuery>;
export type OpenJobsBySectorAndRegionbyYearQueryResult = Apollo.QueryResult<OpenJobsBySectorAndRegionbyYearQuery, OpenJobsBySectorAndRegionbyYearQueryVariables>;
export const TunisiaRegionsDocument = gql`
    query tunisiaRegions {
  regions: regions(names: []) {
    id
    name
  }
}
    `;

/**
 * __useTunisiaRegionsQuery__
 *
 * To run a query within a React component, call `useTunisiaRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTunisiaRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTunisiaRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTunisiaRegionsQuery(baseOptions?: Apollo.QueryHookOptions<TunisiaRegionsQuery, TunisiaRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TunisiaRegionsQuery, TunisiaRegionsQueryVariables>(TunisiaRegionsDocument, options);
      }
export function useTunisiaRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TunisiaRegionsQuery, TunisiaRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TunisiaRegionsQuery, TunisiaRegionsQueryVariables>(TunisiaRegionsDocument, options);
        }
export type TunisiaRegionsQueryHookResult = ReturnType<typeof useTunisiaRegionsQuery>;
export type TunisiaRegionsLazyQueryHookResult = ReturnType<typeof useTunisiaRegionsLazyQuery>;
export type TunisiaRegionsQueryResult = Apollo.QueryResult<TunisiaRegionsQuery, TunisiaRegionsQueryVariables>;
export const RegionsCoordinatesDocument = gql`
    query regionsCoordinates {
  regions: regions(names: []) {
    name
    id
    geoJsonGeometry
  }
}
    `;

/**
 * __useRegionsCoordinatesQuery__
 *
 * To run a query within a React component, call `useRegionsCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionsCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionsCoordinatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegionsCoordinatesQuery(baseOptions?: Apollo.QueryHookOptions<RegionsCoordinatesQuery, RegionsCoordinatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionsCoordinatesQuery, RegionsCoordinatesQueryVariables>(RegionsCoordinatesDocument, options);
      }
export function useRegionsCoordinatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionsCoordinatesQuery, RegionsCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionsCoordinatesQuery, RegionsCoordinatesQueryVariables>(RegionsCoordinatesDocument, options);
        }
export type RegionsCoordinatesQueryHookResult = ReturnType<typeof useRegionsCoordinatesQuery>;
export type RegionsCoordinatesLazyQueryHookResult = ReturnType<typeof useRegionsCoordinatesLazyQuery>;
export type RegionsCoordinatesQueryResult = Apollo.QueryResult<RegionsCoordinatesQuery, RegionsCoordinatesQueryVariables>;
export const NeighbourCountriesWithCoordinatesDocument = gql`
    query neighbourCountriesWithCoordinates {
  regions: regions(names: ["Algeria", "Libya"]) {
    name
    geoJsonGeometry
  }
}
    `;

/**
 * __useNeighbourCountriesWithCoordinatesQuery__
 *
 * To run a query within a React component, call `useNeighbourCountriesWithCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNeighbourCountriesWithCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNeighbourCountriesWithCoordinatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useNeighbourCountriesWithCoordinatesQuery(baseOptions?: Apollo.QueryHookOptions<NeighbourCountriesWithCoordinatesQuery, NeighbourCountriesWithCoordinatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NeighbourCountriesWithCoordinatesQuery, NeighbourCountriesWithCoordinatesQueryVariables>(NeighbourCountriesWithCoordinatesDocument, options);
      }
export function useNeighbourCountriesWithCoordinatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NeighbourCountriesWithCoordinatesQuery, NeighbourCountriesWithCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NeighbourCountriesWithCoordinatesQuery, NeighbourCountriesWithCoordinatesQueryVariables>(NeighbourCountriesWithCoordinatesDocument, options);
        }
export type NeighbourCountriesWithCoordinatesQueryHookResult = ReturnType<typeof useNeighbourCountriesWithCoordinatesQuery>;
export type NeighbourCountriesWithCoordinatesLazyQueryHookResult = ReturnType<typeof useNeighbourCountriesWithCoordinatesLazyQuery>;
export type NeighbourCountriesWithCoordinatesQueryResult = Apollo.QueryResult<NeighbourCountriesWithCoordinatesQuery, NeighbourCountriesWithCoordinatesQueryVariables>;
export const RegionsStatsDocument = gql`
    query regionsStats($year: Int!, $withNumTotal: Boolean!, $withNumEmployed: Boolean!, $withNumUnemployed: Boolean!, $withNumInactive: Boolean!, $withNumOpenJobs: Boolean!) {
  totalPopulation: totalPopulation(year: $year) @include(if: $withNumTotal) {
    region {
      id
      name
    }
    overall
  }
  Employed: employedByAgeGenderSectorAndRegion(year: $year) @include(if: $withNumEmployed) {
    values {
      region {
        id
        name
      }
      overall {
        value
      }
    }
  }
  Unemployed: unemployedByAgeGenderAndRegion(year: $year) @include(if: $withNumUnemployed) {
    values {
      region {
        id
        name
      }
      overall {
        value
      }
    }
  }
  Inactive: inactiveAndUnemployedByRegion(year: $year) @include(if: $withNumInactive) {
    values {
      region {
        id
        name
      }
      overall {
        value
      }
    }
  }
  Job_Openings: openJobsBySectorAndRegion(year: $year) @include(if: $withNumOpenJobs) {
    values {
      region {
        id
        name
      }
      overall {
        value
      }
    }
  }
}
    `;

/**
 * __useRegionsStatsQuery__
 *
 * To run a query within a React component, call `useRegionsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionsStatsQuery({
 *   variables: {
 *      year: // value for 'year'
 *      withNumTotal: // value for 'withNumTotal'
 *      withNumEmployed: // value for 'withNumEmployed'
 *      withNumUnemployed: // value for 'withNumUnemployed'
 *      withNumInactive: // value for 'withNumInactive'
 *      withNumOpenJobs: // value for 'withNumOpenJobs'
 *   },
 * });
 */
export function useRegionsStatsQuery(baseOptions: Apollo.QueryHookOptions<RegionsStatsQuery, RegionsStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionsStatsQuery, RegionsStatsQueryVariables>(RegionsStatsDocument, options);
      }
export function useRegionsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionsStatsQuery, RegionsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionsStatsQuery, RegionsStatsQueryVariables>(RegionsStatsDocument, options);
        }
export type RegionsStatsQueryHookResult = ReturnType<typeof useRegionsStatsQuery>;
export type RegionsStatsLazyQueryHookResult = ReturnType<typeof useRegionsStatsLazyQuery>;
export type RegionsStatsQueryResult = Apollo.QueryResult<RegionsStatsQuery, RegionsStatsQueryVariables>;
export const InsightsDocument = gql`
    query insights($year: Int!, $regionName: String!, $insightType: InsightType!) {
  insights(year: $year, regionName: $regionName, insightType: $insightType)
}
    `;

/**
 * __useInsightsQuery__
 *
 * To run a query within a React component, call `useInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsQuery({
 *   variables: {
 *      year: // value for 'year'
 *      regionName: // value for 'regionName'
 *      insightType: // value for 'insightType'
 *   },
 * });
 */
export function useInsightsQuery(baseOptions: Apollo.QueryHookOptions<InsightsQuery, InsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsQuery, InsightsQueryVariables>(InsightsDocument, options);
      }
export function useInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsQuery, InsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsQuery, InsightsQueryVariables>(InsightsDocument, options);
        }
export type InsightsQueryHookResult = ReturnType<typeof useInsightsQuery>;
export type InsightsLazyQueryHookResult = ReturnType<typeof useInsightsLazyQuery>;
export type InsightsQueryResult = Apollo.QueryResult<InsightsQuery, InsightsQueryVariables>;

declare module '*/queries.graphql' {
  import { DocumentNode } from 'graphql';
  const defaultDocument: DocumentNode;
  export const AgeGenderGroup: DocumentNode;
export const unemployedAgeAndGenderByYear: DocumentNode;
export const employedAgeAndGenderByYear: DocumentNode;
export const inactiveAgeAndGenderByYear: DocumentNode;
export const CompleteNumber: DocumentNode;
export const employedRegionAndSectorAndSubsectorAndAgeAndGenderByYear: DocumentNode;
export const unemployedRegionAndAgeAndGenderByYear: DocumentNode;
export const inactiveReasonsAndRegionAndAgeAndGenderByYear: DocumentNode;
export const inactiveAndUnemployedRegionAndAgeAndGenderByYear: DocumentNode;
export const openJobsBySectorAndRegionbyYear: DocumentNode;
export const tunisiaRegions: DocumentNode;
export const regionsCoordinates: DocumentNode;
export const neighbourCountriesWithCoordinates: DocumentNode;
export const regionsStats: DocumentNode;
export const insights: DocumentNode;

  export default defaultDocument;
}
    